module.exports = __webpack_public_path__ + "img/notasks73.77e69def.svg";